import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Services from './pages/Services';
import Resume from './pages/Resume';
import Articles from './pages/Articles';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import MembersArea from './pages/MembersArea';
import AdminArea from './pages/AdminArea';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="services" element={<Services />} />
            <Route path="resume" element={<Resume />} />
            <Route path="articles" element={<Articles />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="login" element={<Login />} />
            
            {/* Protected Routes */}
            <Route 
              path="members" 
              element={
                <ProtectedRoute>
                  <MembersArea />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="admin" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminArea />
                </ProtectedRoute>
              } 
            />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
